import api from '@api/api';
import { Form } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useForms = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<Form>({
    queryKeyRoot: 'forms',
    apiFn: (params) => api.getForms(params),
    date,
  });

  return { forms: data, isFetching, error, ...rest };
};

export default useForms;
